import { render } from "./modalTemplate.vue?vue&type=template&id=3fa46bfe&scoped=true"
import script from "./modalTemplate.vue?vue&type=script&lang=js"
export * from "./modalTemplate.vue?vue&type=script&lang=js"

import "./modalTemplate.vue?vue&type=style&index=0&id=3fa46bfe&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa46bfe"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/modalTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fa46bfe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fa46bfe', __exports__)) {
    api.reload('3fa46bfe', __exports__)
  }
  
  module.hot.accept("./modalTemplate.vue?vue&type=template&id=3fa46bfe&scoped=true", () => {
    api.rerender('3fa46bfe', render)
  })

}


export default __exports__